import { Component, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControl, FormGroup, Validators } from '@angular/forms';

declare const google: any;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-custom-location-picker',
  templateUrl: './custom-location-picker.component.html',
  styleUrls: ['./custom-location-picker.component.scss'],
})
export class CustomLocationPickerComponent implements OnDestroy {
  @Input() dataLocation: any;
  translations: any;
  registerForm: FormGroup | any;

  get formControls() {
    return this.registerForm.controls;
  }

  constructor(private modalCtrl: ModalController) {
  }

  ngOnInit(){
    this.registerForm = new FormGroup({
      city : new FormControl(this.dataLocation.city),
      country : new FormControl(this.dataLocation.country, Validators.required),
      street : new FormControl(this.dataLocation.street, Validators.required),
      state : new FormControl(this.dataLocation.state, Validators.required),
      zip : new FormControl(this.dataLocation.zip, Validators.required),
      locality : new FormControl(this.dataLocation.locality, Validators.required),
      ext_number : new FormControl(this.dataLocation.ext_number, Validators.required),
    });
  }

  ngOnDestroy() {
  }

  ionViewDidEnter() {
  }


  saveData(){
    this.modalCtrl.dismiss({detailAddress: this.registerForm.value} );
  }

  async close() {
    this.modalCtrl.dismiss();
  }

}
